export const METRIC_VALUES_TO_LABELS: Record<string, string> = {
  // Email metrics
  AverageOrderValue: 'Average Order Value',
  ConversionPerEmailDeliveredRate: 'Conversions / Unique Emails Delivered',
  ConversionPerEmailHoldOutRate: 'Conversions / Email Hold Outs',
  EmailBounceRate: 'Email Bounce Rate',
  EmailClickPerOpenRate: 'Clicks / Opens',
  EmailClickRate: 'Email Click Rate',
  EmailDeliveryRate: 'Email Delivery Rate',
  EmailOpenRate: 'Email Open Rate',
  EmailUnsubscribeRate: 'Email Unsubscribe Rate',
  PurchasePerEmailSendMille: 'Purchases / M (Email)',
  Revenue: 'Revenue',
  RevenuePerEmailSendMille: 'Revenue / M (Email)',
  TotalEmailBounce: 'Total Emails Bounced',
  TotalEmailClick: 'Total Emails Clicked',
  TotalEmailClickBotFiltered: 'Total Emails Clicked (filtered)',
  TotalEmailComplaint: 'Total Complaints',
  TotalEmailComplaintRate: 'Complaint Rate',
  TotalEmailDelivered: 'Total Emails Delivered',
  TotalEmailHoldOut: 'Total Email Holdout',
  TotalEmailOpen: 'Total Email Opens',
  TotalEmailOpensBotFiltered: 'Total Email Opens (filtered)',
  // TODO: Remove TotalEmailOpensFiltered once we remove the AnalyticsBotFiltering feature flag
  TotalEmailOpensFiltered: 'Total Email Opens (filtered)',
  TotalEmailSend: 'Total Email Sends',
  TotalEmailSendSkip: 'Total Email Send Skips',
  TotalHostedUnsubscribeClick: 'Total Hosted Unsubscribe Clicks',
  TotalPurchase: 'Total Purchases',
  TotalUnsubscribe: 'Total Unsubscribes',
  UniqueEmailBounce: 'Unique Emails Bounced',
  UniqueEmailClick: 'Unique Email Clicks',
  UniqueEmailClickBotFiltered: 'Unique Email Clicks (filtered)',
  UniqueEmailClickRate: 'Unique Email Click Rate',
  UniqueEmailDelivered: 'Unique Emails Delivered',
  UniqueEmailOpen: 'Unique Email Opens',
  UniqueEmailOpenOrClick: 'Unique Email Opens Or Clicks',
  UniqueEmailOpensBotFiltered: 'Unique Email Opens (filtered)',
  // TODO: Remove UniqueEmailOpensFiltered once we remove the AnalyticsBotFiltering feature flag
  UniqueEmailOpensFiltered: 'Unique Email Opens (filtered)',
  UniqueEmailOpenRate: 'Unique Email Open Rate',
  UniqueEmailSend: 'Unique Email Sends',
  UniqueHostedUnsubscribeClick: 'Unique Hosted Unsubscribe Clicks',
  UniquePurchase: 'Unique Purchases',
  UniqueUnsubscribe: 'Unique Unsubscribes',

  // Push metrics
  ConversionPerPushDeliveredRate: 'Conversions / Unique Pushes Delivered',
  ConversionPerPushHoldOutRate: 'Conversions / Push Hold Outs',
  PushBounceRate: 'Push Bounce Rate',
  PushDeliveryRate: 'Push Delivery Rate',
  PushOpenRate: 'Push Open Rate',
  PushUnsubscribeRate: 'Push Unsubscribe Rate',
  PurchasePerPushSendMille: 'Purchases / M (Push)',
  RevenuePerPushSendMille: 'Revenue / M (Push)',
  TotalPushBounce: 'Total Pushes Bounced',
  TotalPushDelivered: 'Total Pushes Delivered',
  TotalPushHoldOut: 'Total Push Holdout',
  TotalPushSend: 'Total Pushes Sent',
  TotalPushSendSkip: 'Total Push Send Skips',
  TotalPushUninstall: 'Total App Uninstalls',
  TotalPushOpen: 'Total Pushes Opened',
  UniquePushBounce: 'Unique Pushes Bounced',
  UniquePushDelivered: 'Unique Pushes Delivered',
  UniquePushOpen: 'Unique Pushes Opened',
  UniquePushOpenRate: 'Unique Push Open Rate',
  UniquePushSend: 'Unique Pushes Sent',

  // SMS metrics
  ConversionPerSMSDeliveredRate: 'Conversions / Unique SMS Delivered',
  ConversionPerSMSSendRate: 'Conversions / Unique SMS Sends',
  ConversionPerSMSHoldOutRate: 'Conversions / SMS Hold Outs',
  PurchasePerSMSSendMille: 'Purchases / M (SMS)',
  RevenuePerSMSSendMille: 'Revenue / M (SMS)',
  SMSBounceRate: 'SMS Bounce Rate',
  SMSClickRate: 'SMS Click Rate',
  SMSDeliveryRate: 'SMS Delivery Rate',
  SMSUnsubscribeRate: 'SMS Unsubscribe Rate',
  TotalSMSBounce: 'Total SMS Bounced',
  TotalSMSClick: 'Total SMS Clicks',
  TotalSMSClickBotFiltered: 'Total SMS Clicks (filtered)',
  TotalSMSDelivered: 'Total SMS Delivered',
  TotalSMSHoldOut: 'Total SMS Holdout',
  TotalSMSInbound: 'Total Inbound SMS',
  TotalSMSSend: 'Total SMS Sent',
  TotalSMSSendSkip: 'Total SMS Send Skips',
  UniqueSMSBounce: 'Unique SMS Bounced',
  UniqueSMSClick: 'Unique SMS Clicks',
  UniqueSMSClickBotFiltered: 'Unique SMS Clicks (filtered)',
  UniqueSMSClickRate: 'Unique SMS Click Rate',
  UniqueSMSDelivered: 'Unique SMS Delivered',
  UniqueSMSInbound: 'Unique Inbound SMS',
  UniqueSMSSend: 'Unique SMS Sent',

  // Web Push metrics
  ConversionPerWebPushHoldOutRate: 'Conversions / Web Push Hold Outs',
  ConversionPerWebPushSendRate: 'Conversions / Unique Web Push Sends',
  TotalWebPushClick: 'Total Web Push Clicks',
  TotalWebPushHoldOut: 'Total WebPush Holdout',
  TotalWebPushSend: 'Total Web Pushes Sent',
  TotalWebPushSendSkip: 'Total Web Push Send Skips',
  UniqueWebPushClick: 'Unique Web Push Clicks',
  UniqueWebPushSend: 'Unique Web Pushes Sent',

  // In-App metrics
  ConversionPerInAppHoldOutRate: 'Conversions / In-app Hold Outs',
  ConversionPerInAppOpenRate: 'Conversions / Unique In-app Opens',
  InAppClickRate: 'In-app Click Rate',
  TotalInAppClick: 'Total In-app Clicks',
  TotalInAppClose: 'Total In-app Closes',
  TotalInAppDelete: 'Total In-app Deletes',
  TotalInAppDelivery: 'Total In-apps Delivered',
  TotalInAppHoldOut: 'Total In-app Holdout',
  TotalInAppOpen: 'Total In-app Opens',
  TotalInAppRecall: 'Total In-app Recall',
  TotalInAppSend: 'Total In-app Sent',
  TotalInAppSendSkip: 'Total In-app Send Skips',
  TotalInboxImpression: 'Total Inbox Impressions',
  UniqueInAppClick: 'Unique In-app Clicks',
  UniqueInAppClickRate: 'Unique In-app Click Rate',
  UniqueInAppDelivered: 'Unique In-apps Delivered',
  UniqueInAppOpen: 'Unique In-app Opens',
  UniqueInAppOpenRate: 'Unique In-app Open Rate',
  UniqueInAppSend: 'Unique In-app Sends',

  // Embedded metrics
  EmbeddedClickRate: 'Embedded Click Rate',
  EmbeddedImpressionsRate: 'Embedded Impressions Rate',
  TotalEmbeddedClick: 'Total Embedded Clicks',
  TotalEmbeddedImpression: 'Total Embedded Impressions',
  TotalEmbeddedRetrieved: 'Total Embedded Retrieved',
  UniqueEmbeddedClick: 'Unique Embedded Clicks',
  UniqueEmbeddedImpression: 'Unique Embedded Impressions',
  UniqueEmbeddedRetrieved: 'Unique Embedded Retrieved',

  // WhatsApp metrics
  ConversionPerWhatsAppDeliveredRate: 'Conversions / Unique WhatsApp Delivered',
  PurchasesPerWhatsAppSendMille: 'Purchases / M (WhatsApp)',
  RevenuePerWhatsAppSendMille: 'Revenue / M (WhatsApp)',
  TotalWhatsAppBounce: 'Total WhatsApp Bounced',
  TotalWhatsAppClick: 'Total WhatsApp Clicks',
  TotalWhatsAppDelivered: 'Total WhatsApp Delivered',
  TotalWhatsAppInbound: 'Total WhatsApp Inbound',
  TotalWhatsAppRead: 'Total WhatsApp Reads',
  TotalWhatsAppSend: 'Total WhatsApp Sends',
  TotalWhatsAppSendSkip: 'Total WhatsApp Send Skips',
  UniqueWhatsAppBounce: 'Unique WhatsApp Bounced',
  UniqueWhatsAppClick: 'Unique WhatsApp Clicks',
  UniqueWhatsAppClickRate: 'Unique WhatsApp Click Rate',
  UniqueWhatsAppDelivered: 'Unique WhatsApp Delivered',
  UniqueWhatsAppRead: 'Unique WhatsApp Reads',
  UniqueWhatsAppReadOrClick: 'Unique WhatsApp Reads Or Clicks',
  UniqueWhatsAppReadRate: 'Unique WhatsApp Read Rate',
  UniqueWhatsAppSend: 'Unique WhatsApp Sends',
  WhatsAppBounceRate: 'WhatsApp Bounce Rate',
  WhatsAppClickPerReadRate: 'Clicks / Reads',
  WhatsAppClickRate: 'WhatsApp Click Rate',
  WhatsAppDeliveryRate: 'WhatsApp Delivery Rate',
  WhatsAppReadRate: 'WhatsApp Read Rate',
  WhatsAppUnsubscribeRate: 'WhatsApp Unsubscribe Rate',

  // Custom Conversion metrics
  AverageCustomConversionValue: 'Average Custom Conversion Value',
  SumCustomConversion: 'Sum of Custom Conversions',
  TotalCustomConversion: 'Total Custom Conversions',
  UniqueCustomConversion: 'Unique Custom Conversions',
};

export const HIGH_LEVEL_VALUES_TO_LABELS: Record<string, string> = {
  TotalSent: 'Total Sent',
  UniqueSent: 'Unique Sent',
  TotalSendSkips: 'Total Send Skips',
  TotalDelivered: 'Total Delivered',
  DeliveryRate: 'Delivery Rate',
  TotalOpens: 'Total Opens',
  TotalOpensFiltered: 'Total Opens (filtered)',
  UniqueOpens: 'Unique Opens',
  UniqueOpensFiltered: 'Unique Opens (filtered)',
  UniqueOpenRate: 'Unique Open Rate',
  TotalClicks: 'Total Clicks',
  UniqueClicks: 'Unique Clicks',
  ClickRate: 'Click Rate',
  ClicksPerOpensRate: 'Clicks / Opens',
  TotalUnsubscribes: 'Total Unsubscribes',
  UnsubscribeRate: 'Unsubscribe Rate',
  TotalUninstalls: 'Total App Uninstalls',
  TotalComplaints: 'Total Complaints',
  TotalBounces: 'Total Bounces',
  TotalReplies: 'Total Replies',
  BounceRate: 'Bounce Rate',
  TotalPurchases: 'Total Purchases',
  Revenue: 'Revenue',
  RevenuePerMille: 'Revenue / M',
  PurchasesPerMille: 'Purchases / M',
  TotalCustomConversions: 'Total Conversions',
  ConversionPerSendRate: 'Conversions / Send Delivered',
  ConversionPerHoldOutRate: 'Conversions / Hold Out',
  OpenRate: 'Open Rate',
};
